import React from 'react';
import { GoDotFill } from 'react-icons/go';
import { formatDateAndTime } from '../../function/Helper';

const UserCard = ({ user, handleSelectedChat, selectedUser }: any) => {
  function formatTime(inputTime: string) {
    const inputDate: any = new Date(inputTime);
    const currentDate: any = new Date();
    const diffMs = currentDate - inputDate; // Difference in milliseconds
    const diffMins = Math.floor(diffMs / 60000); // Difference in minutes

    if (diffMins <= 0) {
      return 'Now';
    } else if (diffMins < 60) {
      return `${diffMins} min`;
    } else if (currentDate.toDateString() === inputDate.toDateString()) {
      if (diffMins < 1440) {
        const hours = inputDate.getHours();
        const minutes = inputDate.getMinutes().toString().padStart(2, '0');
        const period = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = (hours % 12 || 12).toString(); // Convert to 12-hour format
        return `${formattedHours}:${minutes} ${period}`;
      } else {
        const diffHours = Math.floor(diffMins / 60);
        return `${diffHours} hr`;
      }
    } else if (
      currentDate.toDateString() !== inputDate.toDateString() &&
      currentDate - inputDate < 2 * 24 * 60 * 60 * 1000 &&
      inputDate.getDate() === currentDate.getDate() - 1
    ) {
      return 'Yesterday';
    } else {
      const formatedDate = `${inputDate.getDate().toString().padStart(2, '0')}/${(inputDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${inputDate.getFullYear()}`;
      const getDate = formatDateAndTime(inputTime);
      return getDate || formatedDate;
    }
  }

  return (
    <div
      onClick={() => handleSelectedChat(user)}
      className={` rounded-lg py-3.5 pl-3.5 md:pr-2 cursor-pointer hover:shadow-[0_0_10px_0px_#006BEA] transition-shadow duration-300 
        ${selectedUser?.id === user.id ? 'border border-[#006BEA] bg-[#006BEA]' : 'border border-transparent bg-[#343434]'}`}
    >
      <div className="flex md:gap-x-6 gap-x-3">
        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-500 text-white font-bold md:text-sm">
          {user.name[0].toUpperCase()}
        </div>
        <div className="flex flex-col">
          <label
            className={`${user.senderType === 'System' && !user.read ? 'font-semibold' : 'font-normal'} text-sm text-white cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap`}
          >
            {user.name}
          </label>
          <label
            className={`${user.senderType === 'System' && !user.read ? 'font-semibold' : 'font-normal'} md:text-sm text-white cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap md:max-w-[500px] lg:max-w-[180px] max-w-[200px] sm:max-w-[340px]`}
          >
            {user.lastMessage}
          </label>
        </div>
        <div className="flex items-start mt-0.5 ml-auto">
          <label
            className={`${user.senderType === 'System' && !user.read ? 'font-semibold' : 'font-normal mr-1.5'} text-xs text-white mr-1`}
          >
            {formatTime(user.date)}
          </label>
          {user.senderType === 'System' && !user.read && (
            <GoDotFill color={'#006BEA'} size={16} className="mt-1.5" />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserCard;
